import { useMutation } from '@tanstack/react-query'

import { authApi } from '../api/authApi'
import type { TPostResetPasswordPayload } from '../api/types/postResetPassword'
import { useConnectSuccess } from './useConnectSuccess'

export const useResetPasswordMutation = (redirectTo?: string) => {
  const onSuccess = useConnectSuccess(redirectTo)

  return useMutation({
    mutationFn: (payload: TPostResetPasswordPayload) => authApi.postResetPassword(payload),
    onSuccess,
  })
}
